import { Controller } from "@hotwired/stimulus"

// This controller is used to swap the display of elements.
export default class extends Controller {
  static get targets() {
    return ["element", "focus"]
  }

  // This action swaps the display of all element targets, when triggered all elements that are hidden become visible
  // and vice versa.
  swap() {
    this.elementTargets.forEach((element) => {
      if (element.classList.contains("d-none")) {
        element.classList.remove("d-none")

        // Focus a specific element is it exists
        if(this.hasFocusTarget) {
          this.focusTarget.focus()
        }
      } else {
        element.classList.add("d-none")
      }
    })
  }
}
